import { Injectable } from "@angular/core";
import { HttpService } from "../providers/http.service";
import { AppConfig } from "../app/app.config";

@Injectable()
export class ImGamingService {
    constructor(private httpService: HttpService, private AppConfig: AppConfig) { }

    /**
     *登录IM电竞
     *An 2019-12-17
     * @returns
     * @memberof ImGamingService
     */
    login(kindId: string = '0') {
        let url = AppConfig.GetProdUrl() + "/Imdj/Login";
        return this.httpService.post(url, { KindID: kindId });
    }

    /**
     * 转账到IM
     * An 2019-12-17
     */
    transferToGamIM(amount: number) {
        let url = AppConfig.GetProdUrl() + "/Imdj/TransferToIm";
        return this.httpService.post(url, { Amount: amount, Type: 0 })
    }
    /**
     *IM转账到平台
     *An 2019-12-17
     * @param {number} amount
     * @returns
     * @memberof ImGamingService
     */
    transferFromIM(amount: number) {
        let url = AppConfig.GetProdUrl() + "/Imdj/TransferFromIm";
        return this.httpService.post(url, { Amount: amount, Type: 1 })
    }

    /**
     *获取IM余额
     *
     * @returns
     * @memberof ImGamingService
     */
    getBalance() {
        let url = AppConfig.GetProdUrl() + "/Imdj/GetBalance";
        return this.httpService.post(url, '')
    }

    /**
     *获取IM转账记录
     *An 2019-12-17
     * @param {*} params
     * @returns
     * @memberof ImGamingService
     */
    GetTransferList(params) {
        let url = AppConfig.GetProdUrl() + "/Imdj/GetTransferList";
        return this.httpService.post(url, params);
    }
    /**
     *获取IM投注记录
     *An 2019-12-17
     * @param {*} params
     * @returns
     * @memberof ImGamingService
     */
    getBettingList(params) {
        let url = AppConfig.GetProdUrl() + "/Imdj/GetBettingList";
        return this.httpService.post(url, params);
    }
     /**
     * 判断im是否开启
     * An 2019-12-17
     */
    imdjIsOpen(){
      let url = AppConfig.GetProdUrl() + "/Imdj/ImdjIsOpen";
      return this.httpService.post(url,"");
  }
     /**
      * im体育登录
      */
      loginImt() {
        let url = AppConfig.GetProdUrl() + "/Im2/Login";
        return this.httpService.post(url, "");
    }
    /**
      * im体育余额
      */
    getImtBalance() {
        let url = AppConfig.GetProdUrl() + "/Im2/GetBalance";
        return this.httpService.post(url, "");
    }
    /**
      * 转账到im体育
      */
    transferToImt(amount: number) {
        let url = AppConfig.GetProdUrl() + "/Im2/TransferToIm";
        return this.httpService.post(url, { Amount: amount, Type: 0 });
    }

    /**
      * 从Im体育转出
      */
    transferFromImt(amount: number) {
        let url = AppConfig.GetProdUrl() + "/Im2/TransferFromIm";
        return this.httpService.post(url, { Amount: amount, Type: 1 });
    }
    /**
      * im体育转账记录
      */
    getImtTransferList() {
        let url = AppConfig.GetProdUrl() + "/Im2/GetTransferList";
        return this.httpService.post(url, "");
    }

    /**
      * im体育投注记录
      */
    getImtBettingList() {
        let url = AppConfig.GetProdUrl() + "/Im2/GetBettingList";
        return this.httpService.post(url, "");
    }

    /**
      * im体育团队报表
      */
    getImtTeamReportList() {
        let url = AppConfig.GetProdUrl() + "/Im2/GetTeamReportList";
        return this.httpService.post(url, "");
    }
    /**
      * im体育个人报表
      */
    getImtUserReportList() {
        let url = AppConfig.GetProdUrl() + "/Im2/GetUserReportList";
        return this.httpService.post(url, "");
    }
    /*
    CR皇冠体育 start

    */

    /**
      * CR皇冠体育登录
      */
    loginCR() {
      let url = AppConfig.GetProdUrl() + "/CR/Login";
      return this.httpService.post(url, "");
    }

    /**
      * CR皇冠体育余额
      */
    getCRBalance() {
      let url = AppConfig.GetProdUrl() + "/CR/GetBalance";
      return this.httpService.post(url, "");
    }
    /**
      * 转账到CR皇冠体育
      */
    transferToCR(amount: number) {
        let url = AppConfig.GetProdUrl() + "/CR/TransferToCR";
        return this.httpService.post(url, { Amount: amount, Type: 0 });
    }

    /**
      * 从CR皇冠体育转出
      */
    transferFromCR(amount: number) {
        let url = AppConfig.GetProdUrl() + "/CR/TransferFromCR";
        return this.httpService.post(url, { Amount: amount, Type: 1 });
    }
    /**
      * CR皇冠体育转账记录
      */
    getCRTransferList() {
        let url = AppConfig.GetProdUrl() + "/CR/GetTransferList";
        return this.httpService.post(url, "");
    }

    /**
      * CR皇冠体育投注记录
      */
    getCRBettingList() {
        let url = AppConfig.GetProdUrl() + "/CR/GetBettingList";
        return this.httpService.post(url, "");
    }

    /**
      * CR皇冠体育团队报表
      */
    getCRTeamReportList() {
        let url = AppConfig.GetProdUrl() + "/CR/GetTeamReportList";
        return this.httpService.post(url, "");
    }

    /**
      * CR皇冠体育个人报表
      */
    getCRUserReportList() {
        let url = AppConfig.GetProdUrl() + "/CR/GetUserReportList";
        return this.httpService.post(url, "");
    }

    /*
    CR皇冠体育 end

    */

    /*
    PG电子 start

    */

    /**
      * PG电子登录
      */
    loginPG() {
      let url = AppConfig.GetProdUrl() + "/PG/Login";
      return this.httpService.post(url, "");
    }

    /**
      * PG电子余额
      */
    getPGBalance() {
      let url = AppConfig.GetProdUrl() + "/PG/GetBalance";
      return this.httpService.post(url, "");
    }
    /**
      * 转账到PG电子
      */
    transferToPG(amount: number) {
        let url = AppConfig.GetProdUrl() + "/PG/TransferToPG";
        return this.httpService.post(url, { Amount: amount, Type: 0 });
    }

    /**
      * 从PG电子转出
      */
    transferFromPG(amount: number) {
        let url = AppConfig.GetProdUrl() + "/PG/TransferFromPG";
        return this.httpService.post(url, { Amount: amount, Type: 1 });
    }
    /**
      * PG电子转账记录
      */
    getPGTransferList() {
        let url = AppConfig.GetProdUrl() + "/PG/GetTransferList";
        return this.httpService.post(url, "");
    }

    /**
      * PG电子投注记录
      */
    getPGBettingList() {
        let url = AppConfig.GetProdUrl() + "/PG/GetBettingList";
        return this.httpService.post(url, "");
    }

    /**
      * PG电子团队报表
      */
    getPGTeamReportList() {
        let url = AppConfig.GetProdUrl() + "/PG/GetTeamReportList";
        return this.httpService.post(url, "");
    }

    /**
      * PG电子个人报表
      */
    getPGUserReportList() {
        let url = AppConfig.GetProdUrl() + "/PG/GetUserReportList";
        return this.httpService.post(url, "");
    }

    /*
    PG电子 end

    */

    /*
    欧博真人 start

    */

    /**
      * 欧博真人登录
      */
    loginOuBo() {
      let url = AppConfig.GetProdUrl() + "/OuBo/Login";
      return this.httpService.post(url, "");
    }

    /**
      * 欧博真人余额
      */
    getOuBoBalance() {
      let url = AppConfig.GetProdUrl() + "/OuBo/GetBalance";
      return this.httpService.post(url, "");
    }
    /**
      * 转账到欧博真人
      */
    transferToOuBo(amount: number) {
        let url = AppConfig.GetProdUrl() + "/OuBo/TransferToOuBo";
        return this.httpService.post(url, { Amount: amount, Type: 0 });
    }

    /**
      * 从欧博真人转出
      */
    transferFromOuBo(amount: number) {
        let url = AppConfig.GetProdUrl() + "/OuBo/TransferFromOuBo";
        return this.httpService.post(url, { Amount: amount, Type: 1 });
    }
    /**
      * 欧博真人转账记录
      */
    getOuBoTransferList() {
        let url = AppConfig.GetProdUrl() + "/OuBo/GetTransferList";
        return this.httpService.post(url, "");
    }

    /**
      * 欧博真人投注记录
      */
    getOuBoBettingList() {
        let url = AppConfig.GetProdUrl() + "/OuBo/GetBettingList";
        return this.httpService.post(url, "");
    }

    /**
      * 欧博真人团队报表
      */
    getOuBoTeamReportList() {
        let url = AppConfig.GetProdUrl() + "/OuBo/GetTeamReportList";
        return this.httpService.post(url, "");
    }

    /**
      * 欧博真人个人报表
      */
    getOuBoUserReportList() {
        let url = AppConfig.GetProdUrl() + "/OuBo/GetUserReportList";
        return this.httpService.post(url, "");
    }

    /*
    欧博真人 end

    */

  /**
   *  获取三方游戏
   */
  getOpenGames() {
    const url = AppConfig.GetProdUrl() + "/System/GetOpenGames";
    return this.httpService.get(url);
  }

  /**
   * 三方游戏登录
   */
  thirdLogin(code) {
    let url = AppConfig.GetProdUrl() + "/" + code + "/Login";
    return this.httpService.post(url, { deviceType: 'mobile' });
  }

  /**
   * 三方游戏余额
   */
  getThirdBalance(code) {
    let url = AppConfig.GetProdUrl() + "/" + code + "/GetBalance";
    return this.httpService.post(url, "");
  }
  /**
   * 转账到三方游戏
   */
  transferToThird(amount: number, code) {
    let url = AppConfig.GetProdUrl() + "/" + code + "/TransferTo";
    return this.httpService.post(url, { Amount: amount, Type: 0 });
  }

  /**
   * 从三方游戏转出
   */
  transferFromThird(amount: number, code) {
    let url = AppConfig.GetProdUrl() + "/" + code + "/TransferFrom";
    return this.httpService.post(url, { Amount: amount, Type: 1 });
  }
  /**
   * 三方游戏转账记录
   */
  getThirdTransferList(params, code) {
    let url = AppConfig.GetProdUrl() + "/" + code + "/GetTransferList";
    return this.httpService.post(url, params);
  }

  /**
   * 三方游戏投注记录
   */
  getThirdBettingList(params, code) {
    let url = AppConfig.GetProdUrl() + "/" + code + "/GetBettingList";
    return this.httpService.post(url, params);
  }

  /**
   * 三方游戏团队报表
   */
  getThirdTeamReportList(params, code) {
    let url = AppConfig.GetProdUrl() + "/" + code + "/GetTeamReportList";
    return this.httpService.post(url, params);
  }

  /**
   * 三方游戏个人报表
   */
  getThirdUserReportList(params, code) {
    let url = AppConfig.GetProdUrl() + "/" + code + "/GetUserReportList";
    return this.httpService.post(url, params);
  }

}



// WEBPACK FOOTER //
// ./src/services/imgaming.service.ts